/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Token_Warning_Market_Risk_DescriptionInputs */

const en_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This asset has warning-state styling ready for market-risk or validation issues.`)
};

const de_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Vermögenswert verfügt über eine Warnstatus-Darstellung für Marktrisiken oder Validierungsprobleme.`)
};

const pt_br2_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ativo tem estilo de alerta pronto para riscos de mercado ou problemas de validação.`)
};

const tr_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu varlık, piyasa riski veya doğrulama sorunları için uyarı durumu stiline hazırdır.`)
};

const zh_cn2_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该资产已配置警示状态样式，可用于市场风险或校验问题提示。`)
};

const zh_hk2_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此資產已備有警示狀態樣式，可用於市場風險或驗證問題。`)
};

const ko_kr2_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 자산에는 시장 리스크 또는 검증 이슈에 대비한 경고 상태 스타일이 적용되어 있습니다.`)
};

const ru_ru2_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для этого актива готово оформление предупреждения на случай рыночного риска или проблем с проверкой.`)
};

const es_419_shared_token_warning_market_risk_description = /** @type {(inputs: Shared_Token_Warning_Market_Risk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este activo tiene el estilo de estado de advertencia listo para problemas de riesgo de mercado o de validación.`)
};

/**
* | output |
* | --- |
* | "This asset has warning-state styling ready for market-risk or validation issues." |
*
* @param {Shared_Token_Warning_Market_Risk_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const shared_token_warning_market_risk_description = /** @type {((inputs?: Shared_Token_Warning_Market_Risk_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Token_Warning_Market_Risk_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_token_warning_market_risk_description(inputs)
	if (locale === "de") return de_shared_token_warning_market_risk_description(inputs)
	if (locale === "pt-BR") return pt_br2_shared_token_warning_market_risk_description(inputs)
	if (locale === "tr") return tr_shared_token_warning_market_risk_description(inputs)
	if (locale === "zh-CN") return zh_cn2_shared_token_warning_market_risk_description(inputs)
	if (locale === "zh-HK") return zh_hk2_shared_token_warning_market_risk_description(inputs)
	if (locale === "ko-KR") return ko_kr2_shared_token_warning_market_risk_description(inputs)
	if (locale === "ru-RU") return ru_ru2_shared_token_warning_market_risk_description(inputs)
	return es_419_shared_token_warning_market_risk_description(inputs)
});